const tooltipActionExpPanel = {
  title: 'Generate New Action'
};

export default tooltipActionExpPanel;
